export default __webpack_public_path__ + "static/media/empty-profile-picture.a9136072.png";